/** @format */

import { takeLeading, put, all, call } from 'redux-saga/effects';

import axios from 'axios';

import {
  getNewHireDataSuccess,
  getNewHireDataFailure,
} from './new-hire.actions';
// import { selectCurrentUser } from '../user/user.selector';

import NewHireActionTypes from './new-hire.types';

export function* getNewHireData() {
  try {
    // const user = yield select(selectCurrentUser);
    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/newhire/data',
      method: 'get',
    });

    if (response.data.status === 'success') {
      yield put(getNewHireDataSuccess(response.data.data));
    } else {
      alert('Error getting New Hire Data ');
    }
  } catch (error) {
    alert('Error on server while getting New Hire Data');
    yield put(getNewHireDataFailure(error));
  }
}

export function* onGetNewHireData() {
  yield takeLeading(NewHireActionTypes.GET_DATA_START, getNewHireData);
}

export function* newHireSagas() {
  yield all([call(onGetNewHireData)]);
}
